var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseApi } from './BaseApi';
var get = /** @class */ (function (_super) {
    __extends(get, _super);
    function get() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    get.prototype.fetch = function (uuid) {
        return this.api.fetch('get', 'user/' + uuid);
    };
    return get;
}(BaseApi));
export { get };
var getAll = /** @class */ (function (_super) {
    __extends(getAll, _super);
    function getAll() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    getAll.prototype.fetch = function () {
        return this.api.fetch('get', 'users');
    };
    return getAll;
}(BaseApi));
export { getAll };
var getPreferences = /** @class */ (function (_super) {
    __extends(getPreferences, _super);
    function getPreferences() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    getPreferences.prototype.fetch = function (uuid) {
        return this.api.fetch('get', 'user/' + uuid + '/preferences');
    };
    return getPreferences;
}(BaseApi));
export { getPreferences };
var getUserNotifications = /** @class */ (function (_super) {
    __extends(getUserNotifications, _super);
    function getUserNotifications() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    getUserNotifications.prototype.fetch = function (uuid) {
        return this.api.fetch('get', 'notifications/' + uuid);
    };
    return getUserNotifications;
}(BaseApi));
export { getUserNotifications };
var getUserNotificationDetails = /** @class */ (function (_super) {
    __extends(getUserNotificationDetails, _super);
    function getUserNotificationDetails() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    getUserNotificationDetails.prototype.fetch = function (params) {
        var notificationUUID = params.notificationUUID, userUUID = params.userUUID;
        return this.api.fetch('get', "notification/".concat(notificationUUID, "/user/").concat(userUUID));
    };
    return getUserNotificationDetails;
}(BaseApi));
export { getUserNotificationDetails };
var readAllUserNotifications = /** @class */ (function (_super) {
    __extends(readAllUserNotifications, _super);
    function readAllUserNotifications() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    readAllUserNotifications.prototype.fetch = function (userUUID) {
        return this.api.fetch('put', "notifications/".concat(userUUID));
    };
    return readAllUserNotifications;
}(BaseApi));
export { readAllUserNotifications };
var create = /** @class */ (function (_super) {
    __extends(create, _super);
    function create() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    create.prototype.fetch = function (params) {
        return this.api.fetch('post', 'user', params);
    };
    return create;
}(BaseApi));
export { create };
var deleteUser = /** @class */ (function (_super) {
    __extends(deleteUser, _super);
    function deleteUser() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    deleteUser.prototype.fetch = function (uuid) {
        return this.api.fetch('delete', 'user/' + uuid);
    };
    return deleteUser;
}(BaseApi));
export { deleteUser };
var putPreferences = /** @class */ (function (_super) {
    __extends(putPreferences, _super);
    function putPreferences() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    putPreferences.prototype.fetch = function (uuid, params) {
        return this.api.fetch('put', 'user/' + uuid + '/preferences', params);
    };
    return putPreferences;
}(BaseApi));
export { putPreferences };
var putAccessData = /** @class */ (function (_super) {
    __extends(putAccessData, _super);
    function putAccessData() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    putAccessData.prototype.fetch = function (uuid, params) {
        return this.api.fetch('put', 'userAccess/' + uuid, params);
    };
    return putAccessData;
}(BaseApi));
export { putAccessData };
var putProfile = /** @class */ (function (_super) {
    __extends(putProfile, _super);
    function putProfile() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    putProfile.prototype.fetch = function (uuid, params) {
        return this.api.fetch('put', 'userProfile/' + uuid, params);
    };
    return putProfile;
}(BaseApi));
export { putProfile };
var createProfile = /** @class */ (function (_super) {
    __extends(createProfile, _super);
    function createProfile() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    createProfile.prototype.fetch = function (uuid, params) {
        return this.api.fetch('post', 'userProfile/' + uuid, params);
    };
    return createProfile;
}(BaseApi));
export { createProfile };
